<template>
    <div class="tabbar" v-if="!$store.state.is_wx || show == 1">
        <!-- 导航栏 -->
        <van-nav-bar :title="$store.state.title" left-text="" :left-arrow="show != 1 ? $store.state.leftArrow : false" @click-left="onClickLeft" id="nav">
            <span slot="title" v-text="msg" class="title flex_c" v-if="msg" v-show="!$store.state.is_wx || show == 1"></span>
            <slot name="title" slot="title"></slot>
        </van-nav-bar>
    </div>
</template>
<style scoped lang="scss">
.tabbar{
  width: 100%;
}
#nav {
  width: 100%;
  height: 40px;
  background-color: #f5f5f5;
}
#nav >div{
  height: 100%;
}
#nav .title{
  font-size: 14px;
  color: #0690db;
  height: 100%;
}
.van-nav-bar__left{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<script>
    import { NavBar } from 'vant'; 
    export default {
        data(){
          return {
            params: ''
          }
        },
        name: 'tabbar',
        props: {
            msg: String,
            goBack: Number,
            target: String,
            show: Number
        },
        created(){
          this.params = this.$route.params;

        },
        methods: {
            onClickLeft() {
              // else if(this.$store.state.userInfo && this.$store.state.token && this.params.goBack == -2){
              //   this.router.replace({
              //     name: 'my'
              //   })
              // }
              if(this.target){
                this.$router.replace({
                  name: this.target
                })
              }else{
                let goBack = this.goBack ? this.goBack : -1;
                this.$router.go(goBack);
              }
            }
        },
    
    }
</script>